export const AssetCustomFieldType = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
} as const;

export type AssetCustomFieldType =
  (typeof AssetCustomFieldType)[keyof typeof AssetCustomFieldType];
